import { PLACEMENT_BLOCK } from '../shared/documentHistoriesConstants';

const BASE_PADDING_DOCUMENT = {
  top: 0, right: 0, bottom: 0, left: 0
};
const SCOPE_OFFER = 'offer';
const IFRAME_PDF_HEIGHT = 1000;
const IFRAME_PDF_WIDTH = 700;
const GAP_PAGE = 25; // estimated gap between each page in the iframe
const MAX_VIEWPORT_SCALE = 1; // Maximum zoom scale automatically assigned to iframe
const DEFAULT_HEIGHT_PAGE_PORTRAIT = '29.6cm';
const DEFAULT_HEIGHT_PAGE_LANDSCAPE = '21cm';
const CLASSNAME_DOCUMENT_PORTAIT = 'html-document-page page-portrait';
const CLASSNAME_DOCUMENT_LANDSCAPE = 'html-document-page page-landscape';
const BASE_FRAME_STYLE = {
  backgroundColor: '',
  borderColor: {
    top: '', left: '', right: '', bottom: ''
  },
  borderWidth: {
    top: 0, left: 0, right: 0, bottom: 0
  },
  borderStyle: {
    top: 'none', left: 'none', right: 'none', bottom: 'none'
  },
  borderRadius: {
    topLeft: 0, topRight: 0, bottomLeft: 0, bottomRight: 0
  },
  backgroundImage: '',
  backgroundSize: 'contain',
  backgroundPosition: 'center center'
};
const DEFAULT_COLOR = '#000000';
const DEFAULT_TAGS = Object.freeze({ STATIC_DOC: 'DOC_STATIQUE' });
const MAX_VERSION_COMMENT_LENGTH = 500;
const PREDEFINED_VARIABLES_FOR_RULES = [{ name: '_pageCourante', type: 'predefined' }];

const ACTION_UNDO = 'undo';
const ACTION_REDO = 'redo';

const DOCUMENT_HISTORY_ACTION_LABELS = {
  CREATION: 'Création',
  ADDITION: 'Ajout',
  DELETION: 'Suppression',
  NAME_UPDATE: 'Modification du nom',
  COMPOSITION_UPDATE: 'Modification de la composition',
  CONDITIONS_UPDATE: 'Modification des conditions',
  CONTENT_UPDATE: 'Modification du contenu',
  DUPLICATED_FROM: 'Dupliqué depuis'
};

const DOCUMENT_HISTORY_BADGE_COLORS = {
  WIDGET: {
    text: 'text-flexi-history-widget',
    bg: 'bg-flexi-history-widget-bg',
    border: 'border-flexi-history-widget-border'
  },
  SECTION: {
    text: 'text-flexi-history-section',
    bg: 'bg-flexi-history-section-bg',
    border: 'border-flexi-history-section-border'
  },
  DOCUMENT: {
    text: 'text-flexi-history-document',
    bg: 'bg-flexi-history-document-bg',
    border: 'border-flexi-history-document-border'
  },
  WIDGET_PLACEMENTS: {
    text: 'text-flexi-history-placement',
    bg: 'bg-flexi-history-placement-bg'
  },
  WIDGET_EXTERNAL: {
    text: 'text-flexi-history-error',
    bg: 'bg-flexi-error-toaster'
  }
};

const PLACEMENT_BLOCK_LABELS = {
  [PLACEMENT_BLOCK.HEADER]: 'En-tête',
  [PLACEMENT_BLOCK.CONTENT]: 'Contenu',
  [PLACEMENT_BLOCK.FOOTER]: 'Pied de page'
};

const DOCUMENT_HISTORY_PAGE_SIZE = 50;

const DOCUMENT_HISTORY_FILTER_DEFAULTS = {
  search: '',
  targetType: null,
  period: 'ALL',
  sort: 'DESC'
};

const DOCUMENT_HISTORY_PERIOD_LABELS = {
  ALL: 'Toutes les périodes',
  CURRENT_MONTH: 'Mois en cours',
  LAST_3_MONTHS: '3 derniers mois',
  LAST_6_MONTHS: '6 derniers mois',
  LAST_12_MONTHS: '12 derniers mois'
};

const DOCUMENT_HISTORY_SORT_LABELS = {
  DESC: 'Plus récent',
  ASC: 'Plus ancien'
};

const PAGE_SIZE = 10;
const PAGE_SIZE_OPTIONS = [5, 10, 15, 20, 25, 50];
const EVEN_ROW_CLASSNAME = '!bg-flexi-col-table/30';

const AUTH_LOGOUT_STORAGE_KEY = 'auth_logout_at';
const AUTH_LOGGED_OUT_ELSEWHERE_PARAM = 'loggedOutElsewhere';

export {
  AUTH_LOGOUT_STORAGE_KEY,
  AUTH_LOGGED_OUT_ELSEWHERE_PARAM,
  BASE_PADDING_DOCUMENT,
  SCOPE_OFFER,
  IFRAME_PDF_HEIGHT,
  IFRAME_PDF_WIDTH,
  DEFAULT_HEIGHT_PAGE_PORTRAIT,
  DEFAULT_HEIGHT_PAGE_LANDSCAPE,
  CLASSNAME_DOCUMENT_PORTAIT,
  CLASSNAME_DOCUMENT_LANDSCAPE,
  BASE_FRAME_STYLE,
  DEFAULT_COLOR,
  DEFAULT_TAGS,
  GAP_PAGE,
  MAX_VIEWPORT_SCALE,
  MAX_VERSION_COMMENT_LENGTH,
  PREDEFINED_VARIABLES_FOR_RULES,
  ACTION_UNDO,
  ACTION_REDO,
  PAGE_SIZE,
  PAGE_SIZE_OPTIONS,
  EVEN_ROW_CLASSNAME,
  DOCUMENT_HISTORY_ACTION_LABELS,
  DOCUMENT_HISTORY_BADGE_COLORS,
  DOCUMENT_HISTORY_PAGE_SIZE,
  DOCUMENT_HISTORY_FILTER_DEFAULTS,
  DOCUMENT_HISTORY_PERIOD_LABELS,
  DOCUMENT_HISTORY_SORT_LABELS,
  PLACEMENT_BLOCK_LABELS
};
